export var LlmProvider;
(function (LlmProvider) {
    LlmProvider["ANTHROPIC"] = "anthropic";
    LlmProvider["GEMINI"] = "gemini";
    LlmProvider["OPENAI"] = "openai";
    LlmProvider["CEREBRAS"] = "cerebras";
    LlmProvider["GROQ"] = "groq";
})(LlmProvider || (LlmProvider = {}));
export var InferenceUseCase;
(function (InferenceUseCase) {
    InferenceUseCase["CONVERSATION"] = "conversation";
    InferenceUseCase["KNOWLEDGE_EXTRACTION"] = "knowledge_extraction";
    InferenceUseCase["PROSPECT_PERSONALIZATION"] = "prospect_personalization";
    InferenceUseCase["POST_DEMO_BRIEF"] = "post_demo_brief";
    InferenceUseCase["CONFIDENCE_SCORING"] = "confidence_scoring";
    InferenceUseCase["BATTLECARD_DETECTION"] = "battlecard_detection";
    InferenceUseCase["FOLLOW_UP_EMAIL"] = "follow_up_email";
    InferenceUseCase["QUALIFICATION"] = "qualification";
    InferenceUseCase["DESIGN_GENERATION"] = "design_generation";
    InferenceUseCase["ONBOARDING_EXPLORATION"] = "onboarding_exploration";
    InferenceUseCase["WALKTHROUGH_NARRATION"] = "walkthrough_narration";
    InferenceUseCase["WALKTHROUGH_HIGHLIGHTS"] = "walkthrough_highlights";
    InferenceUseCase["WALKTHROUGH_OPENING"] = "walkthrough_opening";
    InferenceUseCase["MEETING_SUMMARY"] = "meeting_summary";
    InferenceUseCase["MEETING_ANALYSIS"] = "meeting_analysis";
    /**
     * Post-session analysis for the non-meeting channels (walkthrough now, chat
     * later) — same prompt and rubric as MEETING_ANALYSIS, different evidence.
     * Its own value so cost and volume are attributable per channel: walkthroughs
     * will heavily outnumber demos (post-session-pipeline-2026-08-27.md §6.5),
     * and folding them into MEETING_ANALYSIS would hide exactly the number that
     * decides whether the per-session bar is set right.
     */
    InferenceUseCase["SESSION_ANALYSIS"] = "session_analysis";
    InferenceUseCase["FLOW_VALIDATION"] = "flow_validation";
    InferenceUseCase["VOICE_DEMO_TURN"] = "voice_demo_turn";
    InferenceUseCase["VOICE_TEACHING_TURN"] = "voice_teaching_turn";
    InferenceUseCase["EMBEDDING"] = "embedding";
    /**
     * demand-capture-2026-09-01.md — classifying a chat turn or mining a
     * transcript for a demand signal (missing_feature/requirement/priority/
     * objection). Its own value so this new, unbounded-per-turn cost is
     * attributable separately from CONVERSATION.
     */
    InferenceUseCase["DEMAND_SIGNAL_EXTRACTION"] = "demand_signal_extraction";
    /**
     * C-66 — drafting one flow's proof unit (the claim it proves and the buyer
     * questions it answers). One call per flow, run at onboarding and from the
     * Studio admin action, so its cost is per product, not per session.
     */
    InferenceUseCase["PROOF_UNIT_DRAFT"] = "proof_unit_draft";
    /**
     * 2026-11-03 work item, Lane C — drafting one milestone step's `presenterIntent` (what it
     * shows the buyer and why it matters), modelled on PROOF_UNIT_DRAFT: one call per flow, run
     * on demand from the Studio "Draft missing intents" action, own value so the cost is
     * attributable separately.
     */
    InferenceUseCase["PRESENTER_INTENT_DRAFT"] = "presenter_intent_draft";
    /**
     * insights-actions-2026-09-19.md §2.3 — Tier B: clustering a period's
     * demand_signals + brief objections into named themes. Own value so this
     * per-tenant-period cost is attributable separately from
     * DEMAND_SIGNAL_EXTRACTION (which is per-turn/per-session, not per-period).
     */
    InferenceUseCase["INSIGHT_THEMES"] = "insight_themes";
})(InferenceUseCase || (InferenceUseCase = {}));
//# sourceMappingURL=inference.js.map